export const MAX_WIDTH = 30;
export const MAX_HEIGHT = 100;

export const TEXT_DEFAULT_WIDTH = 30;
export const TEXT_MIN_WIDTH = 2;
export const TEXT_MIN_HEIGHT = 2;

export const IFRAME_DEFAULT_WIDTH = 15;
export const IFRAME_DEFAULT_HEIGHT = 12;
export const IFRAME_MIN_WIDTH = 8;
export const IFRAME_MIN_HEIGHT = 6;

export const CODE_DEFAULT_WIDTH = 30;
export const CODE_MIN_WIDTH = 13;
export const CODE_DEFAULT_HEIGHT = 11;
export const CODE_MIN_HEIGHT = 11;
export const CODE_DEFAULT_INSIDE_WIDTH = 400;

export const QUESTION_DEFAULT_WIDTH = 15;
export const QUESTION_MIN_WIDTH = 6;
export const QUESTION_DEFAULT_HEIGHT = 5;
export const QUESTION_MIN_HEIGHT = 5;
export const QUESION_DEFAULT_INNER_HEIGHT = 30;
export const QUESION_MIN_INNER_HEIGHT = 30;

export const IMAGE_DEFAULT_HEIGHT = 12;
export const IMAGE_DEFAULT_WIDTH = 12;
export const IMAGE_MIN_WIDTH = 1;
export const IMAGE_MIN_HEIGHT = 1;
export const IMAGE_RESPONSIVE_TRIGGER_HEIGHT = 200;
export const IMAGE_RESPONSIVE_TRIGGER_WIDTH = 160;

export const VIDEO_DEFAULT_WIDTH = 15;
export const VIDEO_DEFAULT_HEIGHT = 12;
export const VIDEO_MIN_WIDTH = 8;
export const VIDEO_MIN_HEIGHT = 6;

export const EDITOR_THEME = {
  light: 'base16-light',
  dark: 'base16-dark'
};

export const DEFAULT_IMAGE_CROP = {
  x: 0,
  y: 0,
  w: 100,
  h: 100
};

export const MEDIA_FILE_REGEX = /.+\.(gif|jpg|jpeg|png|bmp|wav|mp3|ttf|otf|txt|json|csv)$/i;
